export function createTriggerOnEnter({
  trigger,
  start,
  onEnter,
  once = true,
  invalidateOnRefresh = true,
}) {
  if (
    !(trigger instanceof HTMLElement) ||
    typeof start !== "string" ||
    typeof onEnter !== "function"
  ) {
    return;
  }

  let hasEntered = false;

  ScrollTrigger.create({
    trigger,
    start,
    once,
    invalidateOnRefresh,
    onEnter: () => {
      if (hasEntered) {
        return;
      }

      hasEntered = true;
      onEnter();
    },
  });
}

export const SUB_SECTION_REVEAL_START = "top 76%";

export function collectRevealTargets(section, selectors) {
  return selectors.flatMap((selector) =>
    Array.from(section.querySelectorAll(selector)).filter(
      (element) => element instanceof HTMLElement,
    ),
  );
}
